import { Box } from '@screentone/core';

import MobileIssueManagementEdit from 'features/mobile-issue-management-edit/MobileIssueManagementEdit';
import { ROLE_TYPE } from 'hooks/roles/types';
import useRequireRoles from 'hooks/roles/useRequireRoles';
import styles from './styles.module.scss';

function SiteConfigMobileIssueManagementEdit() {
  useRequireRoles(ROLE_TYPE.ADMIN);

  return (
    <div className={styles.root}>
      <Box className={styles.box}>
        <Box.Title>Edit Mobile Issue</Box.Title>
        <Box.Content>
          <MobileIssueManagementEdit />
        </Box.Content>
      </Box>
    </div>
  );
}

export default SiteConfigMobileIssueManagementEdit;
